import { observer } from "mobx-react-lite";
import React from "react";
import { assertUnreachable } from "../../../core/utils";
import { BusinessInfoAdmin } from "../../modules/BusinessInfoModule/BusinessInfoAdmin";
import { BusinessReminderAdmin } from "../../modules/BusinessReminder/BusinessReminderAdmin";
import { BusinessModuleType } from "../../modules/types";
import type { BusinessModuleTemplateData } from "../templates/types";

export const BusinessModuleEdit = observer(
  ({
    moduleData,
    onSave,
  }: {
    moduleData: BusinessModuleTemplateData;
    onSave: (moduleData: BusinessModuleTemplateData) => Promise<void>;
  }) => {
    switch (moduleData.type) {
      case BusinessModuleType.Reminder:
        return <BusinessReminderAdmin data={moduleData} onSave={onSave} />;

      case BusinessModuleType.Info:
        return <BusinessInfoAdmin data={moduleData} onSave={onSave} />;

      default:
        assertUnreachable(moduleData);
    }
  },
);
